export const constantData = {
  PROJECT_TITLE: "FMCG",
  SEARCH_PLACE_HOLDER: "What you are looking for ?",
  DATA_NOT_FOUND: "DataNotFound",
  NO_OPTION: "No Option",
  NO_RECENT_SEARCH: "No Recent Search",
  MRP: "MRP",
  PIECE: "peice",
  ROLES: "Roles",
  RIGHTS: "Rights",
  UPDATE: "Update",
  NONE: "none",
  ENTER: "Enter",
  TOTAL_DUE: "Total due",
  OVER_DUE: "Overdue",
  DASHBOARD: "Dashboard",
  ORDER: "Order",
  ORDERS: "Orders",
  PAYMENTS: "Payments",
  BUYERS: "Buyers",
  TEAM: "Department",
  SALES: "Sales",
  OPERATIONS: "Operations",
  ADMIN: "Admin",
  ALTERNATE: "alternate",
  CLIENT: "Client",
  CLIENTS: "Clients",
  CLIENT_DETAILS: "Client Details",
  VIEWALL: "View All",
  TEAM_MEMBER: "Department Members",
  ADD_TEAM_MEMBER: "ADD DEPARTMENT MEMBER",
  CREATE_DELIVERY_ORDER: "CREATE DELIVERY ORDER",
  ADD_AN_ORDER: "ADD AN ORDER",
  ADD_PAYMENT: "Add Payment",
  BLOCKED: "BLOCKED",
  DATE_OF_JOINING: "Date of Joining",
  ERROR: "error",
  EXCESS: "Excess",
  PRICE: "Price",
  ACCEPT: "ACCEPT",
  REJECT: "REJECT",
  REQUIREMENT_ALERT_MESSAGE: "Please provide required data!",
  STRAIGHT_ARROW: "straightArrow",
  OUTSTANDINGS: "Outstanding",
  EARNINGS: "Earnings",
  MONTH_SALES: "This month sales",
  LACS: "Lacs",
  EXPECTED_STRING_MESSAGE: "Expected string but provided ",
  EMPTY_STRING: " is an empty string",
  ROLE_AND_RIGHTS: "Roles & Rights",
  BASIC_DETAILS: "Basic Details",
  MEMBER_FORM: "Member Form",
  DOCUMENTS: "Documents",
  SECURITY: "Security",
  EDIT: "Edit",
  NAME: "Name",
  USER_NAME: "USERNAME",
  EMAIL: "Email",
  PHONE: "Phone",
  JOINING_DATE: "Joining Date",
  STREET: "Street",
  PINCODE: "Pincode",
  CITY: "City",
  STATE: "State",
  COUNTRY: "Country",
  ADD_ONE: "Address Line 1",
  ADD_TWO: "Address Line 2",
  NOT_ASSIGNED: "Unassigned",
  DOCUMENTS_NAME: "Document Name",
  UPLOAD: "UPLOAD",
  ADD_DOCUMENT: "ADD DOCUMENT",
  UPLOAD_DOCUMENTS_ERROR: "Please upload document(pdf or any image).",
  UPLOAD_DOCUMENTS_NAME_ERROR: "Please enter name of Document.",
  UNKNOWN: "Unknown",
  ADD_ACCOUNT: "ADD ACCOUNT",
  ADD_NEW_DOCUMENT: "ADD NEW DOCUMENT",
  ACCOUNT: "Account",
  ACCOUNTS: "Accounts",
  STOCK: "Stock",
  PRODUCTS: "Products",
  ITEMS: "items",
  ITEM: "item",
  HANDLER: "Handler",
  PRIMARY: "Primary",
  GO_TO_PIPELINE: "GO TO PIPELINE",
  CURRENT_PIPELINE_VALUE: "Current Pipeline Value",
  UNSOLD: "unsold",
  REQUIRED: "required",
  PER_CTN: "per ctn",
  PER_PCS: "per pcs",
  PCS: "pcs",
  PIPELINE: "Pipeline",
  SEARCH_PRODUCT: "Search & Add Products",
  PER: "PER",
  CANCEL: "CANCEL",
  SAVE: "SAVE",
  AVAILABLE: "available",
  QTY: "QTY",
  PRICE_PER_PCS: "Price per pcs",
  BACK: "Back",
  UPDATE_ITEM: "UPDATE ITEM",
  RECENTLY_PURCHASED: " Recently Purchased",
  ADVANCE: "Advance",
  UPDATE_QUANTITY: "UPDATE QUANTITY",
  UPDATE_PRICE: "UPDATE PRICE",
  UPDATE_PAYMENT: "UPDATE PAYMENT",
  EXCEEDED_LIMIT: "Exceeded Limit",
  BANK: "BANK",
  CASH: "CASH",
  CARD: "CARD",
  PAYMENT_DATE: "Payment Date",
  MAKE_PAYMENT: "MAKE PAYMENT",
  ENTER_AMOUNT: "Enter Amount",
  CREDIT_USED: "Credit Used",
  CONFIRM: "CONFIRM",
  DONE: "DONE",
  SEND_ORDER_FOR_EXECUTION: "SEND ORDER FOR EXECUTION",
  PRICE_PER_CTN: "Price per ctn",
  ORDER_DETAILS: "Order Details",
  CREDIT_USAGE: "Credit Usage",
  PENDING: "Pending",
  CTN: "ctn",
  REMOVE: "Remove",
  QUANTITY: "Quantity",
  FULFILLED: "Fulfilled",
  CLOSE: "Close",
  EDIT_PIPELINE: "EDIT PIPELINE",
  PROCESS_ORDERS: "Process Order",
  DEFAULT: "default",
  REPORT: "Reports",
  HELP: "Help & Support",
  SETTINGS: "Settings",
  DARK_MODE: "Dark Mode",
  LOGOUT: "Logout",
  WAREHOUSES: "Warehouses",
  WAREHOUSE: "Warehouse",
  ADD_NEW_WAREHOUSE: "ADD NEW WAREHOUSE",
  CREATE_WAREHOUSE: "CREATE WAREHOUSE",
  FOR_AMOUNT: "For amount",
  DELIVERY: "Delivery",
  DISPATCH: "Dispatch",
  LOAD_MORE: "LOAD MORE",
  LEGAL_NAME: "Legal Name",
  TYPE: "Type",
  CREDIT_LIMIT: "Credit Limit",
  CHANGE_LIMIT: "Change Limit",
  NO_CREDIT_LIMIT: "No Credit Limit Granted",
  AMOUNT: "AMOUNT",
  DAYS_: "DAYS",
  ADDRESS: "Address",
  NO_STOCK_FOUND: "No Stock Found",
  ADD_EDIT_ADDRESS: "Add/Edit Address",
  INVOICE_DETAILS: "Invoice Details",
  ADD_INVOICE_DETAILS: "Add Invoice Details",
  SUPPLIER: "Suppliers",
  PURCHASE_INVOICE: "Purchase Invoice",
  ADD_NEW_INVOICE: "ADD INVOICE",
  TOTAL_OUTSTANDING: "Total Outstanding",
  DAY: "Day",
  CHANGE_HANDLER: "Change Handler",
  CURRENT_HANDLER: "Current Handler",
  EDIT_INVOICE_DETAILS: "Edit Invoice Details",
  ADJUST_STOCK_OPENNG: "Adjust Stock Opening",
  PCS_IN_CARTON: "Pieces in Carton",
  CREATE_OPENING: "Create Opening",
  ADD_PRODUCT: "ADD PRODUCTS",
  NET_PRICE: "Net Price",
  NET_DISC: "net disc.",
  REPRESENTATIVE: "Representative",
  LAST_ORDER_UPDATED_BY: "Last Order Updated By",
  LAST_ORDER_UPDATED_ON: "Last Order Updated On",
  ADD: "Add",
  TOTAL_VALUE: "Total Value",
  INCOMING: "Incoming",
  BOOKING: "Booking",
  NET_DISCOUNT: "Net Discount",
  CREATE_ORDER: "Create Order",
  START_TO_ORDER: "START TO ORDER",
  GST_NO: "Gst No",
  SELECT_STATE: "Select State",
  SOMETHING_WENT_WRONG: "Something went wrong",
  CREATE_CLIENT: "CREATE CLIENT",
  COMPANY: "Company",
  ADDITIONAL_DISCOUNT_LABEL: "Dis%. on CR",
  ADDITIONAL_DISCOUNT: "Disc. on Company Rate",
  DISC: "Disc",
  ADD_COMPANY_RATE: "Add Company Rate",
  CONTINUE: "CONTINUE",
  YES: "Yes",
  NO: "No",
  PRICE_BOOK_NOT_SET_YET: "Price book not set yet",
  PREVIOUS: "PREVIOUS",
  NEXT: "NEXT",
  ADD_NEW_CONTACT: "Add New Representative",
  MEMBERS: "Members",
  BLOCK: "Block",
  UNBLOCK: "Unblock",
  ADDRESSES: "Addresses",
  DISCOUNT: "Discount",
  PRODUCTS_NOT_FOUND: "Products not found",
  INCOMING_ORDERS: "Incoming Orders",
  TOTAL: "Total",
  COMPLETED_ORDERS: "Completed Orders",
  ORDER_TYPE: "Order Type",
  DATE_RANGE: "Date Range",
  START_DATE: "Start Date",
  END_DATE: "End Date",
  PROCEED: "Proceed",
  ACCOUNTS_BOOK: "Accounts Book",
  LEDGER: "Ledger",
  DOWNLOAD_LEDGER: "Download Ledger",
  SEARCH: "Search",
  REFRESH_TOKEN_TIMING: 240000,
  RETURN_ORDER_DATE: "Order Return Date",
  SELECT_RETURN_REASON: "Select Return Reason",
  COMMENTS: "Comments",
  SHARE_COMMENTS_HERE: "Share Comments Here",
  NO_PRODUCT_FOUND: "No Product Found",
  SYNC_PRODUCTS: "Sync Products",
  ROLE_AND_PERMISSIONS: "Roles & Permissions",
  PERMISSIONS_ARE_GRANTED: "permissions are granted",
  PERMISSION_IS_GRANTED: "permission is granted",
  SALES_CREDIT_LIMIT: "Sales Credit Limit",
  PURCHASE_CREDIT_LIMIT: "Purchase Credit Limit",
  SALES_LEDGER: "Sales Ledger",
  PURCHASE_LEDGER: "Purchase Ledger",
  VIEW: "VIEW",
  LAST_ORDER: "Last Order",
  PURCHASE_INVOICES: "Purchase Invoices",
  ADDRESS: "Address",
  PURCHASE_ORDERS: "Purchase Order(s)",
  PURCHASE_ORDER: "Purchase Orders",
  CHANGE_PRIMARY_MEMBER: "Change Primary Member",
  VIEW_PURCHASE_ORDER: "View Purchase Order",
  CURRENT_MEMBER: "Current Member",
  CREATE_PURCHASE_INVOICE: "Create Purchase Invoice",
  ADD_MEMBER: "Add Member",
  SALES_ORDERS: "Sales Order(s)",
  ACCOUNT_PROFILE: "Account Profile",
  NO_ORDER_FOUND: "No order found",
  ADD_REPRESENTATIVE: "Add Representative",
  VISIBLE: "visible",
  HIDDEN: "hidden",
  IN_REVIEW: "in review",
  EMPTY_PIPELINE: "Pipeline is empty",
  NO_ORDERS_YET: "No orders yet!",
  MASKED_VALUE: "xxxxx",
  YOU_CAN_NOT_VIEW_ASSESTS: "You can't view these assets.",
  DELIVERED_ORDERS: "There are no delivered orders at the moment.",
  PRINT: "Print",
  SEND_FOR_REVIEW: "Send for review",
  DRAFT: "draft",
  SEND_FOR_APPROVAL: "Send for approval",
  INVOICE: "invoice",
  INVOICES: "invoices",
  APPROVALS_PENDING: "Approval Pending",
  APPROVED: "Approved",
  APPROVE_NOW: "Approve now",
  TOTAL_ORDER_VALUE: "Total order value",
  ALERT: "Alert",
  PURCHASE: "Purchase",
  SALE: "Sale",
  ADD_CLIENT: "ADD CLIENT",
  VIEW_HISTORY: "View History",
  RECEIVED: "Received",
  REVIEW: "Review",
  INCOMING: "Incoming",
  UPLOAD_BANNER: "Upload Banner",
  DELETE: "Delete",
  ADD_MORE_BANNER: "Add More Banner",
  BANNER_NAME: "Banner Name",
  BANNER_POSITION: "Banner Position",
  IMAGE_ALT: "Image Alt",
  EDIT_BANNER: "Edit Banner",
  DELETE_BANNER: "Delete Bannner?",
  DELETE_BANNER_MSG: "Are you sure, you want to delete Banner “Pepsodant Banner”?",
  MY_PROFILE: "My Profile",
  EMPTY_BANNER_LIST: "Your banner list is currently empty.",
  LIMIT_REACHED: "Limit reached",
  OK: "OK",
  DELIVERED_ORDERS_AMOUNT: "Delivered Orders Amount",

  //typography variant

  TYPOGRAPHY_VARIANT: {
    DISPLAY_LARGE: "displayLarge",
    DISPLAY_LARGE_BOLD: "displayLargeBold",
    DISPLAY_MEDIUM: "displayMedium",
    DISPLAY_SMALL: "displaySamll",
    SEMI_BOLD: "semiBold",
    SEMI_BOLD_MEDIUM: "semiBoldMedium",
    SEMI_BOLD_PROMINENT: "semiBoldProminent",
    HEADLINE_MEDIUM: "headlineMedium",
    HEADLINE_SMALL: "headlineSmall",
    HEADLINE_BOLD: "headlineBold",
    TITLE_LARGE: "titleLarge",
    TITLE_MEDIUM: "titleMedium",
    TITLE_BOLD: "titleBold",
    TITLE_SMALL: "titleSmall",
    LABLE_LARGE: "lableLarge",
    LABLE_LARGE_PROMINENT: "lableLargeProminent",
    LABLE_MEDIUM: "lableMedium",
    LABLE_MEDIUM_PROMINENT: "lableMediumProminent",
    LABLE_SMALL: "lableSmall",
    BODY_LARGE: "bodyLarge",
    BODY_MEDIUM: "bodyMedium",
    BODY_SMALL: "bodySmall",
  },

  SEVERITY: {
    ERROR: "error",
    SUCCESS: "success",
    WARNING: "warning",
  },

  ANIMATION: {
    BORDER_RADIUS_30S_EASE_IN_OUT: "border-radius 30s ease-in-out",
  },
  TEXT_FIELD_VARIANT: {
    OUTLINED: "outlined",
    STANDARD: "standard",
  },
  CHIP_VARIANT: {
    FILLED: "filled",
  },

  STYLING: {
    BG_COLOR: "background.paper",
  },
  DATATYPE: {
    STRING: "string",
    OBJECT: "object",
    NUMBER: "number",
    BOOLEAN: "boolean",
    FUNCTION: "function",
  },
  BUTTON_VARIANT: {
    OUTLINED: "outlined",
    CONTAINED: "contained",
    TEXT: "text",
  },

  AVTAR_VARIANT: {
    ROUNDED: "rounded",
    SQUARE: "square",
  },

  STATUS_CODE: {
    CODE404: 404,
    CODE200: 200,
    CODE201: 201,
  },

  SECURITY_UPDATES: {
    CHANGE_PASSWORD: "Change Password",
    NEW_PASSWORD: "New Password",
    CONFIRM_NEW_PASSWORD: "Confirm New Password",
    ENABLE_TWO_FACTOR_AUTHENTICATION: "Enable two factor Authentication",
    UPDATE_PASSWORD: "Update Password",
    LOGOUT_FROM_ALL_DEVICES: "LOGOUT USER FROM ALL DEVICES",
  },

  CREDIT_LIMIT_CARD_MSG: {
    EXCEEDED_CREDIT_LIMIT: "Exceeded Credit Limit by",
    MAX_LIMIT: "You have exceeded to maximum limit of ",
    CREDIT_MAX_LIMIT: "You have a maximum limit of ",
    PAST_CONSUMED_CREDITS: "Past Consumed Credits",
    ORDER_VALUE: "+ Order Value",
    TOTAL_CREDIT_CONSUMED: "= Total Credits Consumed",
    SKIP_FOR_NOW: "SKIP FOR NOW",
    COMPLETED_ORDER_VALUE: "Completed Order Value",
    IN_PROGRESS_ORDER_VALUE: "In-progress Order Value",
    CREDIT_USAGE: "Credit Usage",
    CHANGE_CREDIT_LIMIT: "Change Credit Limit",
    CREDIT_USED: "Credit Used",
    TOTAL_CREDIT_AMOUNT: "Total Credit Amount"
  },

  SHIPPING_ADDRESS_MSG: {
    NEW_SHIPPING: "New Shipping Address",
    ADDRESS_MSG: "We have never delivered to this address of ",
    CONFIRM_ADDRESS_MSG: ". Are you sure want to continue with this address?",
    NEW_SHIPPING_ADDRESS: "Your new shipping address has been approved!",
    NO_APPROVAL_NEEDED: "No Approval needed",
    WE_ARE_GOOD_TO_DELIVER: "We are good to deliver",
    ORDER_APPROVED: "Order approved",
    ORDER_APPROVED_MSG:
      "This order has successfully moved to the execution stage. You can now track its progress under the Execution List section.",
    SAVED_ADDRESS: ". has been saved as your shipping address!",
  },

  PAGE_404_MESSAGES: {
    // CODE_404: "404",
    PRIOR_MSG: "Oops! Page Not Found",
    DESCRIPTION: "The page you're looking for doesn’t exist or has moved.",
    BUTTON_TEXT: "GO TO DASHBOARD",
  },
  POP_OVER_LIST: {
    CANCEL_ORDER: "Cancel Order",
    PUT_ON_HOLD: "Put On Hold",
    DETAILS: "Details",
  },
  TEXT_FIELD_TYPE: {
    PASSWORD: "Password",
    TEXT: "Text",
    FILE: "file",
  },

  ARROW_TYPES: {
    UPWARD_STRAIGHT: "upwardStraight",
    UPWARD_TILT: "upwardTilt",
    DOWNWARD_STRAIGHT: "downwardStraight",
    DOWNWARD_TILT: "downwardTilt",
  },
  HEADINGS: {
    MOST_SOLD_PRODUCT: "Most Sold Products",
    RECENTLY_ADDED: "Recently Added",
    PRICE_DROPPED: "Price Dropped",
    LOWEST_PRICE_PRODUCT: "Lowest Price Product",
    TOP_EARNERS: "Top Earners",
    MY_CLIENTS: "My Clients",
    ORDER_STATUS: "Order Status",
    OUTSTANDING: "Outstanding",
  },

  PRODUCT_CARD_TEXTS: {
    NET_PRICE: "Net Price",
    PER_PCS: "Per pcs",
    PER_CTN: "Per ctn.",
    NET_DISC: "Net Disc.",
    COMPANY_RATE_RATE: "Company Rate",
    ADD_DISC: "Add. Discount",
    EMPTY_MSG: "Product is not available in this warehouse.",
    NO_PRODUCTS_AVAILABLE_IN_WAREHOUSE:
      "None of the selected products are currently available in our warehouses.",
    ITEM_MOVED_TO_EXCLUDED:
      "Items moved to Excluded Items. Please review and update as needed.",
  },

  ORDER_NAME: {
    DELIVERY_ORDER: "Delivery Orders",
    DISPATCH_ORDER: "Dispatch Orders",
    SALES_ORDER: "Sales Order",
    UNFULLFILLED_ITEMS: "Unfullfilled Items",
  },

  TEAM_CATEGORY: {
    SALES: "Sales",
    OPERATIONS: "Operations",
    ADMIN: "Admin",
  },

  DOCUMENTS_TYPE: {
    APPLICATION_PDF: "application/pdf",
    IMAGE_JPG: "image/jpg",
    IMAGE_JPEG: "image/jpeg",
    IMAGE_PNG: "image/png",
  },

  REVIEW_ORDER_SUMMARY: {
    REVIEW_ORDER: "Review Order #",
    ORDER_DATE: "Order Date",
    AMOUNT: "Amount",
    WAREHOUSE: "Warehouse",
    BUYER: "Buyer",
    BILLING_ADDRESS: "Billing Address",
    MODE: "Mode",
    CREDIT_LIMIT: "Credit Limit",
    SHIPPING_ADDRESS: "Shipping Address",
    MSG: "No orders to review at the moment. Please check back later!",
    GOOD_TO_GO: "Good to go",
    LAST_MODIFIED: "Last Modified",
    CHOOSE_ANOTHER: "SELECT OTHER",
    APPROVALS_PENDING: "Approvals pending",
    REJECT: "REJECT",
    APPROVE: "APPROVE",
    EMPTY_LIST_MSG:
      "No products found. Please add at least one product to proceed with the order.",
  },

  IN_EXECUTION_MSG: {
    EMPTY_MSG: "No orders in execution at the moment. Please check back later!",
  },

  IN_DISPATCH_MSG: {
    EMPTY_MSG: "No orders in dispatch at the moment. Please check back later!",
  },

  ADD_ACCOUNT_MSG: {
    MSG: "No Accounts Found! ",
    CREATE_ACCOUNT:
      "You can add a new Supplier or Buyer from this card. Click the respective button below to get started.",
    SELECT_MSG: "Select an account  to create an order.",
    ADD_PIPLINE: "Your pipeline is empty, please add products in pipeline",
    ADD_ACCOUNT: "Add New Supplier / Buyer",
    ADD_BUYER: "ADD BUYER",
    ADD_SUPPLIER: "ADD SUPPLIER",
  },

  PIPELINE_MSG: {
    SELECT_MSG: "Select an item to update its price or quantity! ",
    SAVE_PIPELINE: "SAVE PIPELINE",
    DELIVER_MSG: "We are good to deliver",
    PRODUCT_DETAILS: "Product Details",
    START_ADDING_PRODUCTS: "Start adding products to the pipeline! ",
    CUSTOMER_REQUIREMENTS:
      "It helps you manage and track customer requirements seamlessly.",
    ELIGIBLE_FOR: "Eligible for",
    BULK_ORDER: "Bulk Order",
    ADD_DISCOUNT: "Add. Discount",
    ADD_DISC: "Add. Disc:",
    TO_UNLOCK: "to unlock",
    SELECT: "SELECT",
    ADDITIONAL_DISCOUNT_OF: "Addititonal Discount of",
    PIPELINE_PRODUCT_UPDATED: "Pipeline product has been successfully updated!",
    SELECT_PIPELINE: "Select Client",
    SET_SELLING_PRICE: "Set Selling Price",
    SET_SELLING_PRICE_MSG:
      "Selling price not added yet! Please update to proceed.",
    PIPELINE_READY: "The pipeline is set! Ready to create an order worth",

  },
  PROCESS_ORDER: {
    WE_ARE_GOOD_TO_PROCESS_ORDER: "We are good to Process Order",
    WILL_WE_PROCESS_THE_ORDER_FROM: "will be processed from",
    OF_AMOUNT: "of amount",
    CREATE_PROCESS_ORDER: "CREATE PROCESS ORDER",
    CREDIT_USED: "Consumed Credit",
    TOTAL_AMOUNT: "Total Amount",
    WAREHOUSE: "Warehouse",
    DEALER_DETAILS: "Dealer Details:",
    BILLING_ADDRESS: "Billing Address",
    SEND_ORDER_FOR_REVIEW: "SEND ORDER FOR REVIEW",
    UNFULLFILLED: "EXCLUDED",
    ADD_TO_ORDER: "ADD TO ORDER",
  },

  BILLING_ADDRESS: {
    ADD_BILLING: "Add Billing Address",
    ADD_NEW: "ADD NEW BILLING ADDRESS",
    CONFIRM_ADDRESS: "CONFIRM BILLING ADDRESS",
  },

  SHIPPING_ADDRESS: {
    ADD_SHIPPING: "Add Shipping Address",
    ADD_NEW: "ADD NEW SHIPPING ADDRESS",
    CONFIRM_ADDRESS: "CONFIRM SHIPPING ADDRESS",
  },

  TEAMS_MSG: {
    SELECT_MSG: "Please select a member to view the details.",
    EMPTY_LIST_PRIMARY_MSG: "No members yet!",
    EMPTY_LIST_SECONDARY_MSG: " Please create a member to get started.",
    ADD_ROLES: "ADD ROLES",
    PLEASE_CREATE_TEAM: "Please create a department to get started.",
    NO_TEAM_FOUND: "No department found! ",
    EDIT_TEAM: "Edit Department",
    DELETE_TEAM: "Delete Department",
    ADD_TEAM: "ADD DEPARTMENT",
    ADD_MEMBER: "ADD MEMBER",
    PLEASE_SELECT_TEAM: "Please select department",
  },
  MEMBER_PROFILE_MSG: {
    EMPTY_ORDER_LIST_MSG: "Your order list is empty! Start adding orders now.",
    EMPTY_BUYER_LIST_MSG:
      "Your buyer's list is empty! Add buyers to get started.",
    EMPTY_PAYMENT_LIST_MSG:
      "Your payments list is empty!  Add payments to get started.",
  },

  VIEW_DETAIL_MSG: {
    UPDATE_DETAIL_MSG: "Representative information has been saved successfully.",
    ADDRESS_UPDATED_MSG: "Address has been updated successfully!",
    UPDATE_CLIENT_MSG: "Client information has been successfully updated!",
    UPDATE_PASSWORD_MSG: "Password updated successfully!",
    MSG: "No orders found at the moment. Please check back later!",
    ORDER_MSG: "No orders found. Go to the pipeline to create a new order.",
    PURCHASE_MSG:
      "No purchase orders found. Click the button below to create one.",
    NO_PURCHASE_ORDER: "No purchase orders found",
  },
  CREATE_MEMBER_POPUP: {
    CREATE_MEMBER: "CREATE MEMBER",
    CREATE_MEMBER_MSG: "Please enter basic details to add a new member! ",
    SELECT_ANYONE: "Select Anyone",
    NO_DEPARTMENT_FOUND: "No department found",
    MEMBER_CREATED_MSG: "New department member added successfully!",
  },
  ID: {
    UN_ASSIGNED: "9fd023dc-d615-477b-afe9-c78a2d256c8b",
  },

  ACCOUNT_MSG: {
    CREATE_ACCOUNT: "CREATE SUPPLIER ACCOUNT",
    CREATE_BUYER: "CREATE BUYER ACCOUNT",
    CREATE_ACCOUNT_MSG: "Enter basic details to create a new account!",
    LEGAL_NAME: "Legal Name",
    ACCOUNT_CREATED_MSG: "New account has been created.",
    NO_HANDLER: "No handler assigned!",
    ADD_NOW: "Add Now?",
    HANDLER_UPDATED: "Account handler updated successfully!",
  },

  WAREHOUSE_MSG: {
    CREATE_WAREHOUSE: "Please create one to proceed.",
    EMPTY_LIST: "No warehouse found! ",
    SUCCESS: "New warehouse has been created.",
    CREATE_WAREHOUSE_MSG: "Enter basic details to create a new warehouse! ",
    PRIMARY_MEMBER: "Primary Member",
    NO_MEMBER_FOUND: "No Member Found",
    UPDATE: "Warehouse details have been updated.",
    SELECT_WAREHOUSE: "Select Warehouse",
    PENDING: "Pending",
    DELIVERED: "Delivered",
    CREATE_NEW_INCOMING_ORDER: "CREATE NEW INCOMING ORDER",
    VIEW_EXISTING_INCOMING_ORDERS: "VIEW EXSITING INCOMING ORDER(S)",
    ASSETS: "Assets",
    HANDLER: "Handler",
    RESUME: "Resume",
    VIEW: "View",
    IN_EXECUTION: "In Execution",
    IN_DISPATCH: "In Dispatch",
    SUCCESS: "Warehouse created successfully",
    PLEASE_SELECT_WAREHOUSE: "Please select warehouse",
  },
  COMPANY_REPRESENTATIVE_TEXT: {
    REPRESENTATIVE: "Representative",
    COMPANY_REPRESENTATIVE: "Company Representative",
    ADD_REPRESENTATIVE: "ADD REPRESENTATIVE",
    POSITION: "Position",
    SET_AS_PRIMARY: "Set as Primary",
    BLOCK: "BLOCK",
    UNBLOCK: "UNBLOCK",
    BLOCK_REPRESENTATIVE: "Block Representative",
    BLOCK_CONFIMATION_MSG:
      "Wait! Are you sure you want to block this account representative?",
    UNBLOCK_CONFIMATION_MSG:
      "Are you sure you want to unblock this account representative? They will regain access immediately.",
    NO_REPRESENTATIE_FOUND:
      "You haven’t added any representatives yet! Add a representative to begin.",
  },
  TAX_DETAILS_TEXT: {
    TAX_DETAILS: "Tax Details",
    ADD_ADDRESS: "ADD ADDRESS",
    SET_AS_DEFAULT: "Set as Default",
    ADD_GST: "ADD GST NUMBER",
    ADDRESS_TYPE: "Address Type",
    GST_NUMBER: "GST NUMBER",
    GSTIN: "GSTIN",
    DEFAULT: "Default",
    NO_ADDRESS_FOUND: "No address found! Please add one to continue.",
  },

  DEPARTMENT_MSG: {
    CREATE_DEPARTMENT: "New department created successfully!",
    UPDATE_DEPARTMENT: "Department updated successfully!",
    PRIVILEGES_UPDATED: "Member privileges have been modified!",
    DELETE_TEAM: "Department has been deleted permanently!",
    DEPARTMENT_AND_PRIVILEGES:
      "Department information and access privileges modified successfully!",
  },

  INVOICE_DETAILS_MSG: {
    INVOICE_NO: "Invoice No",
    INVOICE_DATE: "Invoice Date",
    NO_INVOICE: "No invoice found",
    ADD_BATCH_NUMBER: "Add Batch Number",
    ADD_ANOTHER_BATCH: "Add another batch",
    BATCH_NO: "Batch No.",
    MANUFACTURING_DATE: "Mfg. Date.",
    EXPIRY_DATE: "Exp. Date",
    CONFIRM_DELIVERY: "Confirm Goods Received",
    CONFIRM_ITEM: "Confirm Item",
    WAREHOUSE: "Warehouse",
    SUPPLIER: "Supplier",
    ADD_NEW_SUPPLIER: "Add New Supplier",
    SUPPLIER_ADDRESS: "Supplier's Address",
    ADD_NEW_ADDRESS: "Add New Address",
    NO_WAREHOUSE: "No Warehouse Found",
    NO_SUPPLIER: "No suppliers Found",
    CONFIRM_INVOICE: "CONFIRM INVOICE DETAILS",
    NO_ADDRESS: "No Address Found",
    SUCCESS_MSG: "New invoice has been successfully created!",
    NO_INVOICE_FOUND: "No invoices available. Click ADD INVOICE DETAILS button to create one.",
    DELIVERY_CONFIRMED: "Delivery Confirmed",
    ADD_PRODUCTS_MSG: "Search & add products to your invoice effortlessly!",
    ACTION_CARD_MSG:
      "Ready to deliver! Click Confirm Delivery to complete the order.",
    SELECTED_PRODUCTS_MSG: "Select a product to see more details.",
    PURCHASED_QUANTITY: "PURCHASE QUANTITY",
    ADD_BATCH: "Add Batch",
    BATCHES_ADDED: "BATCHES ADDED",
    DELETE_SUCCESS: "The product has been deleted from your list!",
    PRICE_IN_INR: "Price (in inr)",
    SUCCESS_UPDATE: "Product details updated and saved!",
    DRAFT: "draft",
    COMPLETED: "completed",
    ORDER_ID: "Order ID",
    ORDER_DATE: "Order Date",
    LAST_MODIFIED: "Last Modified",
    CREATED_BY: "Created by",
    LAST_MODIFIED_BY: "Last Modified by",
    PURCHASE_ORDER_DETAILS: "Purchase Order Details",
    CONFIRMATION_MSG:
      "Please click the confirm delivery button to stock in the products.",
    APPROVALS_PENDING_MSG: "To send the invoice for approval, please click the Send for Approval button.",
  },

  PATTERN: {
    LIMIT: (limit_type) => `${limit_type} LIMIT`,
    PERCENTAGE_OFF: (percentageOff) => `${percentageOff}% OFF`,
    LAST_DATA: (lastData) => `Last Payment: ${lastData} |`,
    DAYS: (day) => `${day} Days`,
    DAY: (day) => `${day} Day`,
    APPROVALS_REQUIRED: (count) => `${count} Approvals Required`,
    STOCK_QTY: (qty) => `${qty} Quantity`,
    UPDATE_PRICE: (
      currentPrice,
      actualPrice
    ) => `Price of the order (${currentPrice}) doesn’t match with expected price
    (${actualPrice}). Do you want to keep the price?`,
    CONFIRMATION_MSG: (currentPrice) =>
      `Order will be executed with Price ${currentPrice} per pc.`,
    CONFIRMATION_QUANTITY: (qty) =>
      `Order will be executed with ${qty} Quantity`,
    UPDATE_MSG: (price, per, name) =>
      `Price ${price} per ${per} has been approved by ${name}.`,
    PAYMENT: (payment) =>
      `Payment of ${payment} is required to process the order as it exceeds the credit limit.`,
    CREDIT_USED: (amount) => `A credit of  ${amount} remaining.`,
    CREDIT_LIMIT: (amount, day) => `Credit Limit  ${amount} / ${day} days`,
    TOTAL_PRODUCT: (product) => `${product} items`,
    LIMIT_EXCEED: (limit) =>
      `Limit will exceed by ${limit} if you place this order`,
    ITEMS: (item) => `${item} ITEMS`,
    QTY: (qty) => `Qty: ${qty} ctn`,
    PRICE: (price) => `| Price: ${price} per piece`,
    DISCOUNTING_ON: (discounting) => `Discounting on ${discounting}`,
    NO_ORDER: (order) => `You don’t have any orders in ${order}`,
    DELETE_BANNER: (banner) => `Do you really want to remove the ${banner}? Once deleted, it cannot be recovered.`,
    LIMIT_REACHED_MSG: (limit) => `You can add only ${limit} items. Please remove an item to continue.`,
  },
  ALL_PRODUCTS: {
    FILTERS: "Filters",
    SEARCH_CLIENT: "Search Client",
    CLEAR_ALL: "Clear All",
    AVAILABiLITY: "Availability",
    DISCOUNT: "Discount",
    PRICE: "Price",
    PACK_OF: "Pack of ",
    APPLY: "Apply",
    NO_PRODUCT_FOUND: "No Product Found",
    ADD: "ADD",
    FEATURES: "Features",
    SEARCH_PIPELINE: "Search Pipeline or Create Pipeline",
    SEARCH_BY_NAME: "Search by name",
  },

  ADJUST_OPENING: {
    OPENING_STOCK: "Opening Stock",
    SET_OPENING_BALANCE: "Set Opening Balance (in ctn.)",
    SUCCESS_MSG: "New warehouse has been created.",
    SELECT_MSG: "Please Select Product to Update Opening Balance",
    NO_WAREHOUSE_FOUND: "No warehouse found",
    PLEASE_CREATE_WAREHOUSE: "Add a warehouse to proceed.",
    ADD_WAREHOUSE: "ADD WAREHOUSE",
  },
  PRICE_BOOK: {
    DISCOUNT: "Discount %",
    NET_PRICE: "Net Price",
    SET_BULK_RATE: "Set Bulk Rate",
    NET_DISCOUNT_ON_PRODUCT: "Net Discount on Product is",
    UPDATE_SELLING_PRICE: "Update Selling Price",
    SELECT_MSG: "Select a product to set the selling price! ",
    DISCOUNT_MSG: "Set Discount (in ctn.)",
    DISCOUNT_MSG_PCS: "Set Discount (in pcs.)",
    SET_COMPANY_DISCOUNT: "Set Comapany Rate (in ctn.)",
    COMPANY_RATE: "Company Rate",
    ADDITIONAL_DISCOUNT: "Additional Discount (in ctn.)",
    MIN_QUANTITY: "MIN. QTY.",
    ADD_DISCOUNT: "ADD DISC",
    ADD_SLAB: "Add Slab",
    CREATE_SELLING_PRICE_MSG: "The product's selling price has been updated.",
    UPDATE_SELLING_PRICE_MSG: "The product's selling price has been updated.",
    SELLING_PRICE_NOT_SET: "Selling price not set"
  },
  PRODUCT_DETAILS_TEXTS: {
    SPECIAL_PRICE: "Special price",
    OFFERS_AND_INFO: "Offers & Information",
    ADD_TO_CURRENT_PIPELINE: "ADD TO CURRENT PIPELINE",
    ADD_TO_ANOTHER_PIPLINE: "SELECT ANOTHER PIPLINE",
    UPDATE_PRODUCT: "UPDATE PRODUCT",
    IN_STOCK: "In Stock",
    OUT_OF_STOCK: "Out of Stock",
    UPDATE_TO_CURRENT_PIPELINE: "UPDATE TO CURRENT PIPELINE",
  },

  CREATE_ORDER_TEXTS: {
    EXCLUDED_ITEMS: "Excluded Items",
    YOUR_ORDER_FOR: "Your order for",
    YOUR_ORDER_IS: "Your order ID is:",
    OVERFILLED: "Overfilled",
    PARTIAL: "Partial",
    OVERFILLED_MESSAGE:
      "Ordered quantity exceeds available stock. Please adjust your order.",
    PARTIAL_MESSAGE: "Requested Quantity is ",
    AVAILABLE_STOCK: "Available stock",
    OUT_OF_STOCK: "Out of stock"
  },

  STOCK_TEXTS: {
    PRODUCT_STATUS: "Product Status",
    SEARCH_PRODUCT: "Search Products",
    SELECT_STATUS_MSG: "Please select status of the product.",
    SELLING_PRICE_CREATED:
      "The product's selling price has been updated. successfully. ",
  },
  EXECUTE_ORDER_MSG: {
    EXECUTE_ORDER: "Execute Order",
    PARENT_ORDER: "Parent Order",
    SHIPPING_ADDRESS: "Shipping Address",
    BILLING_ADDRESS: "Billing Address",
    EDIT_DISPATCH_ORDER_DETAILS: "EDIT DISPATCH ORDER DETAILS",
    ADD_DISPATCH_ORDER_DETAILS: "ADD DISPATCH ORDER DETAILS",
    CREATE_DISPATCH_ORDER: "CREATE DISPATCH ORDER",
    DISPATCH_ORDER_DETAILS: "Dispatch Order Details",
    DISPATCH_ORDER_MSG:
      "Please enter the dispatch details to continue with the order creation.",
    TRANSPORTATION_TYPE: "Transportation Type",
    TRANSPORTATION: "Transportation",
    TERMS_OF_DELIVERY: "Terms of Delivery",
    DETAILS: "Details",
    VEHICLE_DETAILS: "Vehicle Details",
    ADD_VEHICLE_NUMBER: "Add Vehicle Number",
    ADD_VEHICLE: "ADD VEHICLE",
    ADDITIONAL_CHARGES: "Additional Charges",
    OTHER_CHARGES: "Other Charges",
    OTHER_CHARGES_NAME: "Other Charges Name",
    OTHER_CHARGES_VALUE: "Other Charges Value",
    MODE_OF_TRANSPORTATION: "Mode of Transportation",
    NO_OF_VEHICLE: "No. of Vehicles",
    VEHICLES_NO: "Vehicles No.",
    DETAIL_UPDATED_SUCCESSFULLY: "Dispatch details updated and saved!",
    DELETE_MSG: "Number of vehicles exceeds the entered number.",
  },
  PURCHASE_ORDERS_TEXTS: {
    INCOMING_ORDERS: "Incoming Orders",
    NO_DETAILS_ADDED: "No Details Added Yet",
    CREATE_PURCHASE_ORDER: "Create Purchase Order",
    PURCHASE_ORDER: "Purchase Order",
    SUPPLIER_DETAILS: "Supplier Details",
    CONTACT: "CONTACT",
    NO_CONTACT_FOUND: "No Contact Found",
    FINISH: "FINISH",
    GSTIN: "GSTIN",
    LAST_MODIFIED_ON: "Last Modified on",
    LAST_MODIFIED_BY: "Last Modified By",
    ADDING_PRODUCTS: "Adding Products",
    SELECTED_PRODUCTS: "Selected Products",
    NO_PRODUCT_ADDED: "No Product Added Yet",
    INWARD_WAREHOUSE: "Inward Warehouse",
    WE_ARE_READY_TO_PROCESS_YOUR_ORDER: "Order is ready",
    WILL_BE_PROCESS_THE_ORDER_OF_AMOUNT:
      "will be process the order of amount   ",
    CREATE_INVOICE: "Create Invoice",
    DRAFT_INVOICE: "Draft Invoice",
    EDIT_ORDER: "Edit Order",
    RECENT_PURCHASE: "Recent Purchase from ",
    EMPTY_LIST: "No purchase orders found! Please create one to get started.",
    SELECT_MSG: "Select an order to confirm delivery or make edits!",
    DELIVERED: "Delivered",
    ASSETS: "Assets",
    VIEW_INCOMING_ORDER: "View Incoming Order",
    EDIT_PURCHASE_ORDER: "Edit Purchase Order",
    VIEW_INVOICE: "View Invoice",
    RECOMMENDATION: "Recommendation(s)",
  },
  DISPATCH_ORDER_MSG: {
    DISPATCH_ORDER: "Dispatch Order",
    ORDER_DATE: "Order Date",
    PRIMARY: "Primary",
    HANDLER: "Handler",
    SUPPLIER: "Supplier",
    SHIPPING_ADDRESS: "Shipping Address",
    BILLING_ADDRESS: "Billing Address",
    ORDER_VALUE: "Order Value",
    TOTAL_ITEM_VALUE: "Total Item Value",
    MODE: "Mode",
    ORDER_ID: "Order Id",
    SEE_MORE: "See more",
    VEHICLES_NO: "Vehicles Number",
    GSTIN_UIN: "GSTIN/UIN",
    INCL_GST: "(Incl. GST)",
    DISPATCH_ORDER_DETAILS: "Dispatch Order Details",
    DOWLOAD_INVOICE: "DOWNLOAD INVOICE",
    GENERATE_ESTIMATE: "GENERATE INVOICE",
    MARK_ORDER_COMPLETE: "MARK ORDER COMPLETE",
    OFFICE: "Office",
    DELETE_PRODUCT_MSG:
      "If you delete the last product, this order will be deleted.",
  },
  BOOKS_OF_ACCOUNTS_TEXT: {
    BOOKS_OF_ACCOUNTS: "Books of Accounts",
    RECEIVABLES: "Receivables",
    ADVANCES: "Advances",
    PAYABLE: "Payable",
    SELECT_MSG: "Select an account to make a payment! ",
    PAYMENTS: "Payments",
    EMPTY_MSG: "No accounts available at the moment! ",
  },
  IN_REVIEW_TEXTS: {
    CONSUMED_CREDITS: "Consumed Credits",
    PAST_OVERDUE: "Past Overdue",
    EXCESS_CREDITS_CONSUMED: "Excess Credits Consumed",
    UPDATE_PIPELINE_MSG: "Do you want to update your pipeline?",
    REVIEW_ORDER: "Review Order",
  },
  NOTE_AND_PRINT_TEXTS: {
    VIEW_ADD_NOTES: "View/Add Note",
    VIEW_NOTES: "View Notes",
    PRINT: "Print",
    ALL_NOTES: "All Notes",
    ADD_NEW_NOTE: "Add New Note",
    NOTES: "Notes:",
    EMPTY_NOTES: "Notes are not added yet.",
    NOTES_ARE_NOT_ADDED: "No notes have been added for this invoice.",
  },
  COMPLETED_ORDER: {
    APPLY_DATE_RANGE: "Apply Date Range",
    COMPLETED_ORDER: "Completed Order",
    CREATE_RETURN_ORDER: "CREATE RETURN ORDER",
    CREATE_CREDIT_NOTE: "Create Credit Note",
    CREDIT_NOTES: "Credit Notes",
    RETURN_ORDER_HEADING: "Return Order as per the Invoice ",
    RECENT_PURCHASE_FROM: "Recent Purchase from ",
    RETURN_ORDER: "Return Order as per the invoice",
    SEARCH_PRODUCT: "Search Product",
    PAST_SALE_ORDER: "Past Sale Invoice",
    CREDIT_NOTE: "Credit Note as per the invoice",
    NO_ORDER_FOUND: "No completed orders found! Please check back later.",
    NO_CREDIT_NOTE_FOUND: "No credit notes found! Please check back later.",
    EDIT_CREDIT_NOTE: "Edit Credit Note",
    DELETE_CREDIT_NOTE: "Delete Credit Note",
  },
  CREDIT_LIMIT_MSG: {
    AMOUNT: "Amount",
    DAYS: "Days",
    SALES_CREDIT_LIMIT: "Sales Credit Limit",
    PURCHASE_CREDIT_LIMIT: "Purchase Credit Limit",
  },
  PURCHASE_ORDER_MSGS: {
    ORDER_CREATED: "Order Created",
    ORDER_UPDATED: "Order Updated",
    UPDATED_MSG: "The purchase order has been updated successfully.",
    DETAILED_MSG:
      "You have created a purchase order successfully. It is available to review.",
    NO_PURCHASE_ORDER: "No purchase order found",
    DETAILED_MSG:
      "You have created a purchase order successfully. It is available to review.",
  },
  CREDIT_NOTE_DETAILS: {
    CREDIT_NOTE_DETAILS: "Credit Note Details",
    DATE: "Date",
    ORDER_NO: "Order No",
    ORDER_CREATED: "Credit Note Created",
    ORDER_UPDATED: "Credit Note Updated",
    DETAILED_MSG:
      "You have created a credit note successfully.",
    UPDATED_MSG: "The credit note has been updated successfully.",  
  }
};
